* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.buttons-wrapper {
  height: 18px;

  button {
    background-color: transparent;
    font-family: var(--font-family-secondary);
    color: var(--main-titles-inputs-600);
    border: none;
    padding: 0 2px 2px 2px;
    font-weight: 400;
    cursor: pointer;
    width: 14px;
    height: 16px;
    line-height: 16px;
    color: var(--white-layout-300-primary);

    &:hover {
      background-color: var(--white-layout-050-15-opacity);
    }

    &:focus-visible {
      outline: 1px solid var(--blue-layout-500-focus);
      background-color: var(--blue-layout-305-active);
    }

    &:hover,
    &:focus-visible {
      border-radius: 2px;
    }

    // small font size button
    &:nth-of-type(1) {
      padding-top: 1.5px;
    }

    // default font size button
    &:nth-of-type(2) {
      padding-top: 1px;
    }

    &:nth-of-type(1),
    &:nth-of-type(2) {
      margin-right: 1px;
    }

    &.selected {
      color: var(--blue-layout-301-active);
      &:hover {
        color: var(--blue-layout-301-active);
      }
    }
  }
}

// smaller font size
:host([selectedbuttonvalue='-2px']) {
  .buttons-wrapper {
    height: 20px;
  }
}
